var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationEmptyStateIdeaClassification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#fff;}.e{fill:#212529;}.f{fill:#7e0386;}.g{fill:none;}.h{fill:#eef0f2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 96,
    height: 96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "c",
    className: "h",
    cx: 48,
    cy: 48,
    r: 38
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M57.12,10.63l-21.51,22.02,31.3,7.17-9.78-29.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M67.66,40.5l-33.03-7.57L57.33,9.69l10.33,30.81Zm-31.07-8.14l29.56,6.77-9.24-27.57-20.32,20.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 62.67,
    cy: 58.31,
    r: 13.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M62.67,71.94c-1,0-2.02-.11-3.04-.35-7.33-1.68-11.93-9-10.25-16.33,1.68-7.33,9-11.92,16.33-10.25h0c7.33,1.68,11.93,9,10.25,16.33-1.44,6.31-7.08,10.59-13.29,10.59Zm-.03-26.27c-2.35,0-4.65,.66-6.69,1.94-2.86,1.79-4.85,4.59-5.6,7.88-1.55,6.79,2.7,13.58,9.5,15.14,3.29,.75,6.68,.18,9.54-1.61,2.86-1.79,4.85-4.59,5.6-7.88,1.55-6.79-2.71-13.58-9.5-15.14-.95-.22-1.9-.32-2.84-.32Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M24.02,37.48l22.76,5.21-5.21,22.76-22.76-5.21,5.21-22.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M41.95,66.05l-23.74-5.44,5.43-23.74,23.74,5.44-5.43,23.74Zm-22.54-6.19l21.79,4.99,4.99-21.79-21.79-4.99-4.99,21.79Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEmptyStateIdeaClassification);
export default __webpack_public_path__ + "static/media/illustration_empty-state-idea-classification.d18b29b633230573eb85d6d8379ee3f5.svg";
export { ForwardRef as ReactComponent };